import React from "react";
import {withStyles} from '@material-ui/core/styles';
import Icon from "@material-ui/core/Icon";
import List from '@material-ui/core/List';
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";

const Caption = ({classes, text, subtitle, icon}) => (
    <List disablePadding>
        <ListItem className={classes.captionItem}>
            <ListItemIcon>
                <Icon>{icon}</Icon>
            </ListItemIcon>
            <ListItemText
                primary={(<EllipisWithTooltip>{text}</EllipisWithTooltip>)}
                // classes={{"primary": classes.captionItemText}}
                {...(subtitle && {secondary : subtitle})}
            />
        </ListItem>
    </List>
);

const styles = theme => ({
    captionItem: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    captionItemText: {
        ...theme.helpers.oneLiner,
    },
});

export default withStyles(styles)(Caption);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Drawer/Caption.jsx